export default __webpack_public_path__ + "static/stamp-coffee-cup-0177931ef6a2efad35a85b08cc9144ee.png";